import React, { memo } from 'react';
import { TableCell, TableHead, TableRow, TableSortLabel, makeStyles } from '@material-ui/core';

const useIconStyles = makeStyles((theme) => ({
  sortIcon: (props) => ({
    '&.MuiTableSortLabel-icon': {
      color: props.empty ? 'white' : 'gray',
    },
  }),
}));

const TableHeader = memo(({ tableHead, classes, empty, orderBy, order, onRequestSort }) => {
  const iconClasses = useIconStyles({ empty });

  const createSortHandler = (property) => (event) => {
    if (onRequestSort) {
      onRequestSort(event, property);
    }
  };

  return (
    <TableHead>
      <TableRow>
        {tableHead.map((head) => {
          const isSortable = head.sortable !== false && head.key !== 'index' && head.key !== 'actions';
          return (
            <TableCell
              key={head.key}
              align={head.align}
              className={classes.table_cell_boxes_title}
              style={{
                width: head.width,
                maxWidth: head.width,
                paddingLeft: '4px',
                color: empty ? 'gray' : 'white',
              }}
              sortDirection={orderBy === head.key ? order.toLowerCase() : false}
            >
              {isSortable ? (
                <TableSortLabel
                  active={orderBy === head.key}
                  direction={orderBy === head.key ? order.toLowerCase() : 'asc'}
                  onClick={createSortHandler(head.key)}
                  style={{ color: empty ? 'gray' : 'white' }}
                  classes={{
                    icon: iconClasses.sortIcon,
                  }}
                >
                  {head.label}
                </TableSortLabel>
              ) : (
                head.label
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
});

export default TableHeader;
